import React from "react";
import { useHistory } from "react-router-dom";
import { useIsTablet } from "../../utils/hooks/useIsTablet";
import "./style.scss";

const TabletBackButton = () => {
  const isTablet = useIsTablet();
  const history = useHistory();

  if (!isTablet) return null;

  return (
    <button className="tablet-back-btn" onClick={() => history.goBack()}>
      <i className="ti-arrow-left" />
    </button>
  );
};

export default TabletBackButton;
